import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.16669 15.8334H5.21794L13.7484 7.303L12.6971 6.25175L4.16669 14.7822V15.8334ZM2.91669 17.0834V14.263L13.9088 3.27571C14.0347 3.16126 14.1738 3.07286 14.3261 3.0105C14.4784 2.948 14.6381 2.91675 14.8052 2.91675C14.9723 2.91675 15.1341 2.9464 15.2906 3.00571C15.4473 3.06501 15.586 3.15932 15.7067 3.28862L16.7244 4.31904C16.8537 4.43973 16.9459 4.57862 17.0009 4.73571C17.0559 4.89279 17.0834 5.04987 17.0834 5.20696C17.0834 5.3746 17.0547 5.53453 16.9975 5.68675C16.9403 5.83911 16.8493 5.97828 16.7244 6.10425L5.7371 17.0834H2.91669ZM13.2136 6.78654L12.6971 6.25175L13.7484 7.303L13.2136 6.78654Z",
		fill: "currentColor"
	})
});
export default SvgEdit;
